import React, { useEffect } from 'react';
import { Layout } from '../styles/Hero.styles';

import ResidentsNavbar from './ResidentsNavbar';
import Hero from './Hero';
import Plans from './Plans';
import WhyChooseUs from './WhyChooseUs';
import HowItWorks from './HowItWorks';
import Reviews from './Reviews';
import FAQ from './FAQ';
import Book from './Book';
import Footer from '../util/Footer';

export default function ResidentsPage(props: any) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout style={{ background: '#D3F7FF' }}>
      <ResidentsNavbar />
      <Hero />
      <Plans />
      <WhyChooseUs />
      <HowItWorks />
      <Reviews />
      <FAQ />
      <Book />
      <Footer {...props} />
    </Layout>
  );
}
